// extracted by mini-css-extract-plugin
module.exports = {"container":"container__19R8a","header":"header__3Tq8P","main":"main__dUl5U","menu":"menu__37rKg","body":"body__tlKgk"};